import { api } from 'api'
import { WorkStatusEnum } from './shiftTimeline'

type GetEligibleLeadShiftsRequest = {
  companyId: number
  shiftId: number
}

type GetEligibleLeadShiftsResponseWork = {
  status: WorkStatusEnum
  worker: {
    id: number
    name: string
    profilePicUrl?: string
  }
}

type GetEligibleLeadShiftsResponseLeadShift = {
  id: number
  startsAt: string
  endsAt: string
  workersNeeded: number
  position: {
    id: number
    name: string
  }
  location: {
    id: number
    name: string
    timezone: string | null
  } | null
  work: GetEligibleLeadShiftsResponseWork[]
}

type GetEligibleLeadShiftsResponse = {
  eligibleLeadShifts: GetEligibleLeadShiftsResponseLeadShift[]
}

export async function getEligibleLeadShifts(
  { companyId, shiftId }: GetEligibleLeadShiftsRequest,
  signal?: AbortSignal
) {
  const response = await api.get<GetEligibleLeadShiftsResponse>(
    `/company/${companyId}/shifts/${shiftId}/eligible_lead_shifts`,
    { signal }
  )

  return response.data.eligibleLeadShifts
}
